import { Directive,ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';


@Directive({
    selector : '[hideElement]',
  })

  export class HideElementDirective {

    navigationPageSubscription: Subscription;

    constructor(private el: ElementRef, private appService: AppService){
        this.navigationPageSubscription = this.appService.workmateAppLinkSubject.subscribe((data) => {
            if (data) {
                this.el.nativeElement.style.display = 'none';;
            }
        })
    }

    ngOnDestroy(){
        if(this.navigationPageSubscription){
            this.navigationPageSubscription.unsubscribe();
        }
    }
  
  }